import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from '../shared/utils-service';

@Component({
  selector: 'app-mass-search-customers',
  templateUrl: './mass-search-customers.component.html',
  styleUrls: ['./mass-search-customers.component.css']
})
export class MassSearchCustomersComponent implements OnInit {

	private loggedInUser: any = {};
    constructor(private router: Router, private utils: UtilsService) { 
    	this.loggedInUser = this.utils._checkSession({'page': 'mass-search-customers'});
    }


  ngOnInit() {

  }
  templateUpload= function () {
          this.router.navigateByUrl('/template-upload');
  }
  downloadFile() {
    //window.location.href='/src/user_files/BatchEnquirySampleData.csv';
    window.location.href='/ddmf/assets/BatchEnquirySampleData.csv';
  }
  
  massSearchHistory(){
  	this.router.navigateByUrl('/telco-audit-trail/mass-search-customers-history');
  }
   goToURL(url){
		this.router.navigateByUrl(url);
		}

}



// WEBPACK FOOTER //
// ./src/app/mass-search-customers/mass-search-customers.component.ts